import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { AuthService } from './auth.service';
import { AuthJWTService } from './jwt/auth-jwt.service';

@Injectable()
export class AuthGuardAuthenticated implements CanActivate, CanActivateChild {

  constructor(public authService: AuthService, private authJwtService: AuthJWTService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    return this.authService.isLoggedIn() && this.authService.isAuthenticated();

  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    return this.authService.isLoggedIn() && this.authService.isAuthenticated();

  }

}



// WEBPACK FOOTER //
// ./client/app/core/auth/auth-guard-authenticated.ts